import React from 'react';

import './footer.scss';

import { Link } from 'react-router-dom';

import bg from '../../assets/footer-bg.jpg';
import logo from '../../assets/mv.png';

const Footer = () => {
    return (
        <div className="footer" style={{ backgroundImage: `url(${bg})` }}>
            <div className="footer__content container">
                <div className="footer__content__logo">
                    <div className="logo">
                        <img src={logo} alt="" />
                        <Link to="/">BCT36 Movie</Link>
                    </div>
                </div>

                <div className="footer__desc">
                    <p><strong>Beat Cẩm Thủy 36 Movies</strong> - Trang xem phim online miễn phí chất lượng cao Vietsub, thuyết minh, lồng tiếng Full HD – 4K. Kho phim mới khổng lồ gồm phim chiếu rạp, phim bộ, phim lẻ từ Việt Nam, Hàn Quốc, Trung Quốc, Thái Lan, Nhật Bản, Âu Mỹ… đa dạng thể loại.</p>
                </div>

                <div className="footer__content__main">
                    <div className="footer__app">
                        <p className="footer__app__title">TẢI ỨNG DỤNG TRÊN THIẾT BỊ DI ĐỘNG</p>
                        <div className="footer__app__badges">
                            <a
                                href="https://bct36.io.vn/Phim/trailer/beatcamthuy36movie.apk"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer__app__badge"
                            >
                                <img
                                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                                    alt="Tải APK Android"
                                />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="footer__copyright">
                    © 2026 BCT36 Movie
                </div>
            </div>
        </div>
    );
}

export default Footer;
